import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class ProductDimensionFilterData {
    dimensions: Array<DropdownOptionIntegerId>;
}
